export const KITOPI_APP_STORE_ADJUST_REDIRECT =
  'https://kitopi-rewards.go.link?adj_t=19njxhg3_19tl0v0z';

export const KITOPI_APP_STORE_ADD_TO_CART =
  'https://kitopi-rewards.go.link/dinein?adj_t=1u8hd2op_1uckf52e';

export const KITOPI_APP_STORE_CASHBACK_BANNER =
  'https://kitopi-rewards.go.link/home?adj_t=1he8f8sh_1hp1312v';
